import { createFeatureSelector, createSelector } from "@ngrx/store";

import { State, CoreFeatureState } from "../reducers";
import { State as CoreState } from "../reducers/core.reducer";
import { Screen } from "../../models/screen.model";

export const coreFeatureState =
  createFeatureSelector<CoreFeatureState>("core_feature");

export const coreState = createSelector(
  coreFeatureState,
  (state: CoreFeatureState): CoreState => state.core,
);

export const getScreen = createSelector(
  coreState,
  (state: CoreState): Screen => state.screen,
);

export const getBreadcrumb = createSelector(
  coreState,
  (state: CoreState) => state.breadcrumb,
);

export const getScrollPosition = createSelector(
  coreState,
  (state: CoreState) => state.scrollPosition,
);
